import React from "react";
import "./CancelCreateQuoteModal.css";
import {ReactComponent as Alerticon} from "../../../assets/icons/alert.svg";
import { Button, Col, Modal, Typography } from "antd";
const CreateQuoteValidationModal = (props) => {
  const { Text } = Typography;
  const {
    open,
    handleOk,
    errorMessages,
    confirmButtonText = "EDIT QUOTE",

    // data = ""
  } = props;

  const isGrouped = errorMessages?.some((item) => item && typeof item === "object");
  const totalErrorCount = isGrouped
    ? errorMessages.reduce((count, group) => count + (group.errors?.length || 0), 0)
    : errorMessages?.length;

  return (
    <>
      <Modal
        className="Cancel-Create-QuoteModal"
        title={
          <div className="d-flex align-items-center">
            <Alerticon style={{ marginRight: 8 }} />
            Errors found
          </div>
        }
        onCancel={handleOk}
        open={open}
        footer={[
          <Col className="cancel-footer-container">
            <Button onClick={handleOk} className="cancel-button">
              CANCEL
            </Button>
            <Button
              onClick={() => handleOk()}
              className=""style={{
                height: "48px",
                maxWidth: "200px",
                width: "100%",
                fontWeight: 500,
                fontSize: "14px",
                color: "white",
                backgroundColor: "#0354a3",
                border: "none",
              }}
            >
             {confirmButtonText}
            </Button>
          </Col>,
        ]}
      >
        <Col className="error-container-modal">
        <Col>
        <Text className="error-modal-tilte">{totalErrorCount} errors found. Please fix them to publish</Text>
        </Col>
          <Col className="outer-error">
          {isGrouped
            ? errorMessages.map((group, groupIndex) => (
                <div className="error-group" key={groupIndex}>
                  {group.vendorLabel && (
                    <Text className="error-group-title">{group.vendorLabel}</Text>
                  )}
                  {group.errors.map((err, index) => (
                    <div className="error-item-row" key={index}>
                      {err.sno && <span className="error-item-sno">Sno {err.sno}{err.itemLabel ? ` - "${err.itemLabel}"` : ""}:</span>}
                      {" "}{err.message}
                    </div>
                  ))}
                </div>
              ))
            : errorMessages.map((errorMessage, index) => (
                <div className="error-text-outer" key={index}>{errorMessage}</div>
              ))}
          </Col>
        </Col>
      </Modal>
    </>
  );
};

export default CreateQuoteValidationModal;
